import { Component } from 'sane-ui'
// import canAutoplay from 'can-autoplay'
import gsap from 'gsap'
require('waypoints/lib/noframework.waypoints.js')
const Waypoint = window.Waypoint

class VideoPlayer extends Component {
  constructor ($el, args) {
    super($el, args)

    this.$video = this.$el.find('video')
    this.$poster = this.$el.find('.media-item__poster')
    this.video = this.$video.get(0)
    this.$playBtn = this.$el.find('.media-item__video-btn')
    this.$workCard = this.$el.closest('.work-card')
    this.$CSCard = this.$el.closest('.work-card--case_study')
    this.isPlayBtnVisible = false
    this.isWorkCard = this.$workCard.length > 0 && this.$workCard.hasClass('work-card')
    this.isCSCard = this.$CSCard.length > 0 && this.$CSCard.hasClass('work-card--case_study')
    this.isPlaying = false

    const dataAutoplay = this.$el.data('autoplay')
    const autoplay = dataAutoplay !== undefined ? dataAutoplay : false

    if (!autoplay) {
      this.setupPlayButton()
      return
    }

    if (this.isWorkCard) {
      if (window.matchMedia('(pointer: coarse)').matches) {
        // is touch.
        if (this.isCSCard) {
          this.setupInView()
        }
      } else {
        this.setupOnHover()
      }
    } else {
      this.setupInView()
      // if (result === true) {
      //   // Can autoplay
      // } else {
      //   // Cannot autoplay
      //   this.setupPlayButton()
      // }
    }
    // canAutoplay.video({ inline: true, muted: true, timeout: 750 }).then(({ result }) => {
    // })
  }

  setupPlayButton () {
    gsap.to(this.$playBtn, { autoAlpha: 1, duration: 0.2, ease: 'none' })

    this.$playBtn.on(
      'click',
      () => {
        if (this.video.paused) {
          this.playVideo()
        } else {
          this.pauseVideo()
        }
      }
    )

    $(this.video)
      .on('play', () => { this.togglePlayBtn(false) })
      .on('pause', () => { this.togglePlayBtn(true) })
  }

  /**
   * Toggle the visibility of the play button.
   *
   * @param {boolean|'auto'} show Whether to show or hide the button.
   */
  togglePlayBtn (show = 'auto') {
    show = show === 'auto' ? !this.isPlayBtnVisible : show
    gsap.to(this.$playBtn, { opacity: show ? 1 : 0, duration: 0.2, ease: 'none' })
    this.isPlayBtnVisible = show
  }

  /**
   * Play and pause a video as it comes in and out of the viewport respectively.
   */
  setupInView () {
    this.waypointTop = new Waypoint({
      element: this.$el.get(0),
      handler: (direction) => {
        if (direction === 'down') {
          this.playVideo()
        } else {
          this.pauseVideo()
        }
      },
      offset: window.innerHeight,
    })

    this.waypointBottom = new Waypoint({
      element: this.$el.get(0),
      handler: (direction) => {
        if (direction === 'down') {
          this.pauseVideo()
        } else {
          this.playVideo()
        }
      },
      offset: window.innerHeight * -1,
    })
  }

  setupOnHover () {
    this.$el.hover(
      () => { this.playVideo() },
      () => {
        // revert back to poster.
        this.stopVideo()
      }
    )
  }

  playVideo () {
    this.isPlaying = true
    gsap.set(this.$video, { autoAlpha: 1 })
    this.video.play()

    this.$video.one(
      'playing', () => {
        if (this.isPlaying) {
          gsap.set(this.$poster, { autoAlpha: 0, transition: 'none' })
        }
      }
    )
  }

  pauseVideo () {
    this.isPlaying = false
    this.video.pause()
  }

  stopVideo () {
    this.isPlaying = false
    gsap.set(this.$poster, { autoAlpha: 1 })
    gsap.set(this.$video, { autoAlpha: 0 })
    this.video.pause()
    this.video.currentTime = 0
  }

  destroy () {
    if (this.waypointTop !== undefined) {
      this.waypointTop.destroy()
    }
    if (this.waypointBottom !== undefined) {
      this.waypointBottom.destroy()
    }
  }
}

export default VideoPlayer



// WEBPACK FOOTER //
// ./scripts/components/VideoPlayer.js